import { z } from "zod";

import { EOption, forOptions } from "@/schemas/project-register.schema";

// import { EOption, forOptions } from "./schemas/project-register.schema";

export const TOptions = EOption.merge(z.object({ for: forOptions }));

export const NewEstimateOptions = z.object({
  data: z.array(TOptions),
});

export type TypeTOptions = z.infer<typeof TOptions>;

export type TNewEstimateOptions = z.infer<typeof NewEstimateOptions>;

export type TAllOptions = z.infer<typeof TOptions>;

export type AllForOptions = z.infer<typeof forOptions>;
